import { useLanguageContext } from "../../../context/LanguageContext";
import PrinterPage from "../../../pages/printers/printer/PrinterPage";
import { usePrinterCreateRouteValidator } from "../../validators/printers/PrinterCreateRouteValidator";
import { RouteConfig } from "../RouteConfig";
import usePrintersRouteConfig from "./PrintersRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function usePrinterCreateRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/printers/create")
    .setLabel(
      translate("eva.main.entities.states.create", [
        {
          key: "entities",
          value: translate("eva.main.entities.printer"),
        },
      ])
    )
    .setValidator(usePrinterCreateRouteValidator())
    .setPage(<PrinterPage />)
    .setParent(usePrintersRouteConfig());
}

export default usePrinterCreateRouteConfig;
